import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './se-selected-facets.css.lit';

type Facet = { label: string; url: string };
/**
 * The SeSelectedFacets component
 * @element se-selected-facets
 */
@customElement('se-selected-facets')
export class SeSelectedFacets extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: Array })
  facets: Array<Facet>;

  render(): TemplateResult {
    if (this.facets.length > 0) {
      return html` <div class="se-selected-facets">
        <ul class="facets">
          ${this.facets.map(facet => {
            if (facet.label !== 'Clear all') {
              return html`<li class="bullet">
                ${facet.label}
                <a
                  href="${facet.url}"
                  aria-label="Remove filter ${facet.label}"
                  class="bullet-remove"
                >
                  <outline-icon
                    name="x"
                    library="system"
                    size="0.75rem"
                    color="brand-neutral-white"
                  ></outline-icon>
                </a>
              </li>`;
            }
            return html`<li class="clear-btn">
              <a href="${facet.url}">${facet.label}</a>
            </li>`;
          })}
        </ul>
      </div>`;
    } else return html``;
  }
}
